import { useTranslation } from "react-i18next";
import styles from "./Login.mobile.module.css";
import { useLoginController } from "../Login.controller";
import InputView from "../../../components/input/Input.view";
import React from "react";
import LoaderView from "../../../components/loader/Loader.view.tsx";
import { getVersion } from "../../../tools/ConfigurationReader.ts";

export default function LoginMobileView() {
  const { t } = useTranslation();
  const {
    username,
    setUsername,
    password,
    setPassword,
    handleLoginClick,
    loading,
    usernames,
    handleChipClick,
    passwordRef,
  } = useLoginController();

  return (
    <div className={styles.container}>
      {loading && <LoaderView />}

      {!loading && (
        <>
          <img
            className={styles.logo}
            src="/images/logo.png"
            alt={t("ui.altLogo")}
          />
          <InputView
            placeholder={t("ui.placeholderForEmail")}
            value={username}
            width={300}
            onChange={(e) => setUsername(e.target.value)}
          />
          <div className={styles.space} />
          <InputView
            ref={passwordRef}
            type="password"
            placeholder={t("ui.placeholderForPassword")}
            value={password}
            width={300}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className={styles.space} />
          <button className={styles.button} onClick={handleLoginClick}>
            {t("ui.login")}
          </button>
          <div className={styles.space} />
          <div className={styles.version}>{getVersion()}</div>

          <div className={styles.usernamesContainer}>
            {usernames &&
              usernames.map((username: string) => (
                <span
                  key={username}
                  className={styles.usernames}
                  onClick={() => handleChipClick(username)}
                >
                  {username}
                </span>
              ))}
          </div>
        </>
      )}
    </div>
  );
}
